module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp11-9825bbe95ac6da68714e7f68e0332093.jpg";